export default __webpack_public_path__ + "img/accha/accha5.webp";